import accounting from 'accounting';
import moment from 'moment';
import _ from 'lodash';
import { reformatNum } from './FormUtil';

export const elipsis = (string, maxLength) => {
  if (string.length > maxLength) {
    const word = string.substr(0, maxLength - 1).trim();
    return `${word}...`;
  }
  return string.trim();
};

export const capitalize = s => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const formatMoney = string =>
  accounting.formatMoney(reformatNum(string), 'Rp', 0, '.');

export const formatIDR = string =>
  accounting.formatMoney(string, 'IDR ', 2, '.', ',');

export const unFormat = string => accounting.unformat(string, true);

export const formatPhoneNumber = string =>
  (string || '').substring(0, 1) === '0' ? string : `+${string}`;

export const unifyPhoneNumber = string => {
  const number = (string || '').replace(/^\D+/g, '');
  return number.substring(0, 2) === '62' ? number.replace('62', '0') : number;
};

export const formatDateDMY = string => moment(string).format('D MMMM YYYY');

export const formatDateTime = string =>
  moment(string).format('DD-MMM-YYYY • HH:mm');

export const formatDateTimeDetail = string =>
  moment(string).format('DD-MMM-YYYY, HH:mm');

export const formatDateTimeMonth12H = string =>
  moment(string).format('MMMM DD, YYYY, HH:mm A');

export const formatDateTimeMonthDetail = string =>
  moment(string).format('MMMM DD, YYYY, HH:mm:ss.SSS');

export const formatDateTimeDetailWib = string =>
  `${moment(string).format('DD-MMM-YYYY, HH:mm')} WIB`;

export const formatDate = string => {
  if (string) {
    return moment(string).format('DD-MMM-YYYY');
  }
  return '-';
};

export const formatTime = string => moment(string).format('HH:mm:ss');

export const formatTimeWib = string => {
  if (string) {
    const convertFormat = moment(string).format('HH:mm');
    return `${convertFormat} WIB`;
  }
  return `-`;
};

export const maskString = string => {
  const splited = string.split(' ');
  const len = splited.length;
  let result = '';
  _.forEach(splited, (char, index) => {
    if (index === 0) {
      result += `${char.substring(0, 3) +
        char.substring(2, char.length).replace(/./g, '•')} `;
    } else if (index === len - 1) {
      result +=
        char.substring(0, char.length - 3).replace(/./g, '•') +
        char.substring(char.length - 3, char.length);
    } else {
      result += `${char.replace(/./g, '•')} `;
    }
  });

  return result;
};
